import { render, staticRenderFns } from "./UserActiveModal.vue?vue&type=template&id=d56e6b78"
import script from "./UserActiveModal.vue?vue&type=script&lang=js"
export * from "./UserActiveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports